/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as defs from './identity/defs'
export * as getRecommendedDidCredentials from './identity/getRecommendedDidCredentials'
export * as refreshIdentity from './identity/refreshIdentity'
export * as requestPlcOperationSignature from './identity/requestPlcOperationSignature'
export * as resolveDid from './identity/resolveDid'
export * as resolveHandle from './identity/resolveHandle'
export * as resolveIdentity from './identity/resolveIdentity'
export * as signPlcOperation from './identity/signPlcOperation'
export * as submitPlcOperation from './identity/submitPlcOperation'
export * as updateHandle from './identity/updateHandle'
